module.exports = __webpack_public_path__ + "img/MDEX.291c6120.png";